import { InjectionToken } from '@angular/core';
import { SoldTo } from '../../../core/model';
import { Occ } from '../../../core/occ/occ-models';
import { Converter } from '../../../core/util/converter.service';

export const SOLD_TO_NORMALIZER = new InjectionToken<Converter<Occ.SoldTo, SoldTo>>('SoldToNormalizer');
